import React from "react";
import Navbar from "../Components/Navbar";
import Home from "./Home";

function Layout() {
  return (
    <>
      <Navbar />
      <Home />
    </>
  );
}

export default Layout;
